// loguer les erreurs js de la page paiement
if (document.location.href.indexOf("/paiement/") > 0) {
	window.onerror = function (errorMsg, url, lineNumber, errorObj) {
		let objectConfig = $("#scriptPaiement").text();
		let message = `Error: ${errorMsg} - Script: ${url} - Line : ${lineNumber} - StackTrace : ${errorObj}`;
		let title = `Erreur paiement.js - Script: ${url} - Line : ${lineNumber}`;

		commons.ErreurJs(title, message, objectConfig);
	}
}


class Paiement extends Inscription {

	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		super.initialize();
		// super.form();
		let self = this;

		let choixCB = document.getElementById('carteCredit');

		let acompteValue = config.path === 'paiementlibre' ? config.montant : config.acompte;
		let montantMax = Math.round(acompteValue * 0.75);
		let montantMin = Math.round(acompteValue * 0.25);

		if (choixCB != null) {
			choixCB.addEventListener('change', function (el) {
				if (config.path === 'tunnel') {
					self.changeCarteCredit(el);
				} else {
					let nbCarte = parseInt(el.target.value);
					// Si deux cartes, on divise le montant à payer en deux
					acompteValue = nbCarte === 2 ? Math.round(acompteValue / 2) : acompteValue;
					let data = nbCarte === 2 ? "soit entre " + montantMin + " et " + montantMax + " " + config.deviseAffiche : "";
					self._switchCard(acompteValue, data, nbCarte);
				}
			});
		}

		let arrayBtnInfos = ['infoPaiementCB', 'infoPaiementVirement', 'infoPaiementCheque'];
		arrayBtnInfos.forEach((el) => {
			if (document.getElementById(el) !== null) {
				document.getElementById(el).addEventListener('click', function (el) {
					let template = el.target.dataset.template;
					let title = el.target.innerText;
					self.modalInfoPaiement(template, title);
				});
			}
		});

		let btnDisplayPaiment = document.querySelectorAll('button.choix__paiement');

		btnDisplayPaiment.forEach((btn) => {
			btn.addEventListener('click', function (el) {
				let element = el.target;
				[...element.parentElement.parentElement.children].forEach(sib => {
					sib.children[0].classList.remove('is-active')
				})
				element.classList.add('is-active');
				let target = element.dataset.target;
				document.getElementById(target).checked = true;
			})
		});


		let formCBPaybox = document.getElementById('paiementCBForm');

		if (formCBPaybox != null) {

			formCBPaybox.onclick = (event) => {

				let nbCarte = parseInt(document.getElementById('carteCredit').value);
				let montant2 = document.getElementById('montant2').value;

				if (nbCarte === 2) {
					if (montant2 > 0) {
						return self.initPaiementCB();
					} else if (self.controleMulticarte(montantMin, montantMax) == "")
						return self.initPaiementCB();
					else {
						event.preventDefault();
					}
				} else {
					return self.initPaiementCB();
				}
			}

			self.backCBPaiement();
		}

	}

	controleMulticarte(min, max) {
		var message = "";
		let montant1 = document.getElementById('montant1').value;

		if (montant1 == "" || montant1 == 0) {
			message = "* le montant est obligatoire";
		} else if (Number.isInteger(parseInt(montant1))) {

			montant1 = parseInt(montant1);

			if (montant1 != 0 && (montant1 < min || montant1 > max)) {
				message = "* le montant n'est pas compris entre " + min + " et " + max + " " + config.deviseAffiche;
			}
		} else {
			message = "* le montant est invalide";
		}

		document.getElementById("erreurMontant1").innerText = message;
		document.getElementById('erreurMontant1').style.display = 'block';

		return message;
	}


	modalInfoPaiement(idTemplate, titleModale) {
		modalPopup.overrideStyles = false;
		modalPopup.init("", titleModale);
		document.querySelector(modalPopup.items.popupModal).classList.add('modal--paiement-information');
		const utilities = new utilitiesInscription(config);
		utilities._templating(idTemplate, 'popupContent');
	}

	backCBPaiement() {
		let self = this;
		//si 3 tentatives echec, rendre invisible la partie paiement carte bancaire et on affiche le premier moyen de paiement disponible
		if (config.nbEssaiPaybox >= 3 || config.nbEssai3Dsecure >= 3) {

			document.querySelector('[data-target="toggleVirement"]').classList.add('is-active');

			let li = document.querySelectorAll('.paiement__panel li');
			document.querySelector('#cb + .paiement__type .input__select--paiement').checked = true;
			li[0].classList.add('is-active');
			document.getElementById('cb').style.display = 'none';
		} else {
			/// Cas paiement CB n°2
			if (config.isMulticarte) {

				document.getElementById('carteCredit').value = 2;

				/// On empêche de payer en virement si l'on a payé par CB
				if (config.PaiementCarte1Ok) {

					if (document.querySelector('[data-target="toggleVirement"]') !== null) {
						document.querySelector('[data-target="toggleVirement"]').style.display = 'none';
					}

					let arrayIdTypePaiement = ['virement', 'cheque', 'optionSansEngagement', 'devisSansEngagement'];

					for (var i = 0; i < arrayIdTypePaiement.length; i++) {
						if (document.getElementById(arrayIdTypePaiement[i]) !== null) {
							document.getElementById(arrayIdTypePaiement[i]).style.display = 'none';
						}
					}

					document.querySelector('.paiement__panel').style.display = 'none';
					document.getElementById('titreMoyenPaiement').style.display = 'none';

					self._switchCard(Math.round(config.montantCarte2), '', 2)
				} else {

					let montantMax = Math.round(config.acompte * 0.75);
					let montantMin = Math.round(config.acompte * 0.25);
					var data = "soit entre " + montantMin + " et " + montantMax + " " + config.deviseAffiche;
					self._switchCard(Math.round(config.acompte / 2), data, 2)
				}
			} else {
				let radio = document.querySelectorAll('[name="toggle"]');
				for (var i = 0; i < radio.length; i++) {
					// document.querySelectorAll('.choix__paiement ').forEach(sib => {
					// 	sib.children[0].classList.remove('is-active')
					// });
					if (radio[i].checked) {
						let id = radio[i].id;
						document.querySelector(`[data-target="${id}"]`).classList.add('is-active');
					}
				}
			}
		}
	}

	/// Ajax toggle carte crédit 1 & 2
	changeCarteCredit(el) {
		let self = this;
		let nbCarte = el.target.value;
		let accomptePredefini = Math.round(config.acompte / 2);

		$.ajax({
			url: config.url.changeCarteCredit,
			async: false, ///important!appel syncrone
			data: {
				codeProduit: config.codeProduit,
				dateDepart: config.dateDepart,
				nbCarte: nbCarte,
				numdossierCrypte: config.numdossierCrypte
			},
			type: "POST",
			success: function (data) {
				self._switchCard(accomptePredefini, data, nbCarte);

			},
			error: function (data) {
				console.error(data);
			}
		});
	}

	_switchCard(acompte, data, nbCarte) {

		if (nbCarte == 2) {
			if (!config.PaiementCarte1Ok) {
				document.getElementById('zoneCarte1').style.display = 'block';
				document.getElementById('zoneCarte2').style.display = 'none';
				document.getElementById('textComplementaire').innerText = data;
				document.getElementById('montant1').value = acompte;
			} else {
				document.getElementById('zoneCarte2').style.display = 'block';
				document.getElementById('zoneCarte1').style.display = 'none';
				document.getElementById('textComplementaire').innerText = data;
				document.getElementById('montant2').value = acompte;
				document.getElementById('fieldsetCarteCredit').style.display = 'none';
			}

		} else {
			document.getElementById('zoneCarte2').style.display = 'none';
			document.getElementById('zoneCarte1').style.display = 'none';

		}

		//document.getElementById('nom').value = '';
		document.getElementById('erreurMontant1').style.display = 'none';
	}

	initPaiementCB() {
		
		let self = this;
		let emailContact = config.emailContact;
		let PaiementCarte1Ok = config.PaiementCarte1Ok;
		let nbEssaiPaybox = config.nbEssaiPaybox;
		let montant = config.montant;

		let nbCarte = parseInt(document.getElementById('carteCredit').value);
		let isCarte1 = false;
		let isCarte2 = false;
		let nomTitulaire = document.getElementById('nomPayeur').value;

		if (nomTitulaire == "") {

			document.getElementById("erreurNomPayeur").innerText = "* Le nom du titulaire de la carte est obligatoire";
			document.getElementById('erreurNomPayeur').style.display = 'block';
			return false;
		}

		// le client a choisi deux cartes de crédit
		if (nbCarte === 2) {
			// Première CB
			if (!PaiementCarte1Ok) {
				montant = document.getElementById('montant1').value;
				isCarte1 = true;
			}
			// Deuxième CB
			else {
				montant = config.montantCarte2;
				isCarte2 = true;
			}
		}

		let newCodeProduit = newCodeProduit || '';

		if (config.path !== 'paiementlibre') {
			newCodeProduit = self._verifierDonnee(config.numdossier);
		}

		if (newCodeProduit == '') {
			let data = {
				montant: montant.replace('.', ','),
				numdossier: config.numdossier,
				devise: config.devise,
				isCarte1: isCarte1,
				isCarte2: isCarte2,
				emailContact: emailContact,
				nbEssaiPaybox: nbEssaiPaybox,
				nomTitulaire : nomTitulaire
			}

			if (config.page === 'solde') {
				data.typeLibelleMttAPayer = config.typeLibelleMttAPayer;
			}

			$.ajax({
				url: config.url.initPaiementCB,
				async: false,
				data: data,
				type: "POST",
				success: function (data) {
					document.getElementById('divFormPaybox').innerHTML = data;
					let formCBPaybox = document.getElementById('paiementCBForm');
					formCBPaybox.submit();

				},
				error: function (data) {
					console.error(data);
				}
			});
			return true;
		} else {
			if (config.path === 'tunnel') {
				modalPopup.callback = function () {
					document.querySelector(modalPopup.items.popupModal).classList.add('modal--alert');
				}
				modalPopup.callback();
				modalPopup.init("Une erreur s'est produite lors de votre inscription . <br/> Peut-être avez vous plusieurs onglets ouverts sur des réservations différentes ? <br/>Si c'est le cas, veuillez fermer vos onglets et recommencer votre inscription");
			} else {
				window.location.href = newCodeProduit;
			}

			return false;
		}
	}

	_verifierDonnee(numeroDossier) {
		let newCodeProduit = '';
		let data = {
			numdossier: numeroDossier
		}

		$.ajax({
			url: config.url.verifierDonnee,
			async: false,
			data: data,
			type: "POST",
			success: function (data) {
				newCodeProduit = data;
			},
			error: function (data) {
				console.error(data);
			}
		});

		return newCodeProduit;
	}
}